import React , { useEffect, useContext } from 'react';
import {useDeviceStatus} from '../runningtrack/DeviceStatusProvider';
import DeviceAlertBadge from '../runningtrack/DeviceAlertBadge';
import styled, { css } from 'styled-components';
import palette from '../../lib/styles/palette';
import { NavLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import lockerIcon from '../../resources/images/svg/lock-24px.svg';
import Logo from './Logo';
import {
  FiSettings,
  FiUser,
  FiBriefcase,
  FiCalendar,
  FiDollarSign,
  FiBarChart,
  FiShoppingCart,
  FiMonitor,
  FiEdit,
  FiKey,
} from 'react-icons/fi';
import {FaMobileAlt} from 'react-icons/fa';
import {RiCoupon2Line} from 'react-icons/ri';
import {
  ImEnter
} from 'react-icons/im';
import { MdLocalParking, MdDirectionsRun } from 'react-icons/md';
import { COACH_MENU_KEYS, isMenuHiddenForCoach } from '../../lib/def/coachMenu';

const navigation = [
  /* {
    name: 'attendance',
    text: '출석관리',
    url: '/attendance',
  },*/

  {
    name: 'dashboard',
    text: '전지점 매출 현황',
    url: '/dashboard',
    icon: function () {
      return <FiBriefcase />;
    },
  },
  {
    name: 'memeber',
    text: '회원',
    url: '/member?page=1&searchText=',
    icon: function () {
      return <FiUser />;
    },
  },
  {
    name: 'attend',
    text: '출입 기록',
    url: '/attend',
    icon: function () {
      return <ImEnter />;
    },
  },
  {
    name: 'locker',
    text: '락커',
    url: '/locker',
    icon: function () {
      return <LockerIcon src={lockerIcon} />
    },
  },
  {
    name: 'lesson',
    text: '레슨',
    url: '/lesson',
    icon: function () {
      return <FiCalendar />
    },
  },
  {
    name: 'kiosk',
    text: '키오스크',
    url: '/kiosk/product',
    icon: function () {
      return <FiMonitor />;
    },
  },
  {
    name: 'mobileProduct',
    text: '모바일 판매',
    url: '/mobileProduct',
    icon: function () {
      return <FiShoppingCart />;
    },
  },
  {
    name: 'mobile',
    text: '광고/홍보',
    url: '/mobile',
    icon: function () {
      return <FaMobileAlt />;
    },
  },
  {
    name: 'sales',
    text: '매출',
    url: '/sales',
    icon: function () {
      return <FiDollarSign />;
    },
  },
  {
    name: 'statistics',
    text: '통계',
    url: '/statistics',
    icon: function () {
      return <FiBarChart />;
    },
  },
  {
    name: 'point',
    text: '포인트',
    url: '/point',
    icon: function () {
      return <MdLocalParking />;
    },
  },
  {
    name: 'runningtrack',
    text: '제타트랙',
    url: '/runningtrack',
    icon: function () {
      return <MdDirectionsRun />;
    },
  },
  {
    name: 'prescription',
    text: '기록 & 처방',
    url: '/prescription',
    icon: function () {
      return <FiEdit />;
    },
  },
  {
    name: 'coupon',
    text: '트랩 쿠폰',
    url: '/coupon',
    icon: function () {
      return <RiCoupon2Line />;
    },
  },
  {
    name: 'configuration',
    text: '설정',
    url: '/configuration/item',
    icon: function () {
      return <FiSettings />;
    },
  },
];

const NavigationBlock = styled.div`
  display: flex;
  width: 240px;
  height: 100%;
  position: fixed;
  min-width: 150px;
  flex-direction: column;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  background: white;
  z-index: 10;
  @media screen and (max-width: 1600px) {
    width: 200px;
  }
  @media screen and (max-width: 768px) {
    display: none;
  }
`;
const LockerIcon = styled.img`
  width: 16.8px;
  height: 16.8px;
`;
const StyledMenu = css`
  color: ${palette.webBlack[9]};
  font-size: 1rem;
  display: flex;
  align-items: center;
  width: 150px;
  margin-left: 36px;
  margin-right: 36px;
  @media screen and (max-width: 1600px) {
    width: 150px;
    font-size: 0.8rem;
  }
`;
const StyledLink = styled(NavLink)`
  ${StyledMenu}

  > .device-menu-label { margin-right: 0; }

  span {
    margin-right: 10px;
    font-size: 1.05rem;
    @media screen and (max-width: 1600px) {
      font-size: 0.9rem;
    }
  }
`;
const StyledUl = styled.ul`
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledLi = styled.li`
  margin-top: 1.25rem;
  & .active {
    filter: invert(33%) sepia(95%) saturate(1756%) hue-rotate(201deg) brightness(94%) contrast(95%);
  }
`;
const svgStyle = {
  marginRight: '15px',
};

const activeStyle = {
  color: palette.webCyan[5],
  fontWeight: 'bold',
};

const Navigation = () => {
    const {hasUnread: hasDeviceAlert} = useDeviceStatus();
    const {
        currentClub,
        user,
        myMenuHidden,
        myMenuLoaded,
      } = useSelector(({ user, club, socket, coach }) => ({
        currentClub: club.defaultClub,
        user: user.user,
        myMenuHidden: coach.myMenuHidden,
        myMenuLoaded: coach.myMenuLoaded,
    }));

    let testClubID = localStorage.getItem("testClubID")


  return (
    <NavigationBlock>
      <Logo />
      <StyledUl>
          {navigation.map((menu) => {
            if (!currentClub) return false
            if (user && user.memberType !== 3 && menu.name == 'dashboard') return false
            if (currentClub && currentClub.pointActive == 0 && menu.name == 'point') return false
            if (currentClub && currentClub.attendActive == 0 && menu.name == 'attend') return false
            if (currentClub && currentClub.couponFlag == 0 && menu.name == 'coupon') return false
            if (currentClub && currentClub.runningTrack == 0 && menu.name == 'runningtrack') return false
            if (currentClub && currentClub.kiosk == 0 && menu.name == 'kiosk') return false
            // CRM 접속권한 강사(memberType 6)는 관리자가 설정한(숨기지 않은) 메뉴만 노출.
            // 본인 설정 로드 전에는 관리 대상 메뉴를 숨겨(hide-until-loaded) 라우트 가드와 동작을 맞추고
            // 숨겨야 할 메뉴가 잠깐 노출되는 깜빡임을 방지한다.
            if (user && Number(user.memberType) === 6 && COACH_MENU_KEYS.indexOf(menu.name) !== -1) {
              if (!myMenuLoaded) return false
              if (isMenuHiddenForCoach(menu.name, currentClub, myMenuHidden)) return false
            }

            return(
              <StyledLi key={menu.name} style={{position: 'relative'}}>
                <StyledLink to={menu.url} activeStyle={activeStyle}>
                  <span className={menu.text && menu.text=="locker" ? "active" : ""}>{menu.icon()}</span>
                  <span className={menu.name === 'runningtrack' ? 'device-menu-label' : undefined}>{menu.text}</span>
                  {menu.name === 'runningtrack' && <DeviceAlertBadge visible={hasDeviceAlert}/>}
                </StyledLink>
              </StyledLi>
            )
          })}
      </StyledUl>
      {
        (user && (user.memberType === 1 || user.memberType === 2))?
        <div style={{marginTop: '2rem', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            <StyledLi key={'admin'} style={{position: 'relative', marginTop:'20px'}}>
                <StyledLink to={'/admin'} activeStyle={activeStyle}>
                    <span className={'admin'}>{<FiKey />}</span>
                    <span>{'Admin'}</span>
                </StyledLink>
            </StyledLi>
        </div>
        :null
      }
    </NavigationBlock>
  );
};

export default Navigation;
